import { Box } from "@outschool/backpack";
import { Search } from "@outschool/business-rules";
import { Checkbox } from "@outschool/ui-legacy-component-library";
import _ from "lodash";
import React from "react";

import { useActivityString } from "../../../../../shared/hooks/useActivityString";
import { Filter } from "../Filter";
import { ListingChildFilterProps } from "./ListingFilters";

export default function ThemeFilter({
  searchFilters,
  onChange,
  selectedSearchToggle
}: ListingChildFilterProps & {
  selectedSearchToggle: Search.SearchToggleType;
}) {
  const themes = searchFilters.theme ? searchFilters.theme.split(",") : [];
  const subjects = Search.getSubjectForSearchToggle(selectedSearchToggle);

  const { translateThemeName } = useActivityString();
  return (
    <Filter showTopBorder={false}>
      <Box
        sx={{
          padding: "12px 24px 24px 0px",
          fontSize: "1em"
        }}
      >
        {subjects.map(theme => (
          <Checkbox
            key={theme}
            id={theme}
            label={translateThemeName(theme)}
            checked={themes.some(s => s === theme)}
            iconSize="1em"
            onChange={e => {
              const checked = e.target.checked;
              const newValues = checked
                ? [...themes, theme]
                : _.without(themes, theme);
              // @ts-ignore TS(2722): Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
              onChange({
                // @ts-ignore TS(2322): Type 'string | null' is not assignable to type 'st... Remove this comment to see the full error message
                theme: Array.isArray(newValues) ? newValues.join(",") : null
              });
            }}
            sx={{
              cursor: "pointer",
              marginBottom: "small"
            }}
          />
        ))}
      </Box>
    </Filter>
  );
}
